<script lang="ts">
  import { Button, Col, Modal, ModalBody, Row } from "sveltestrap"
  import { shortenAddress, txLink } from "../utils/utils"
  import { currentChainId } from "../stores/store"

  export let isOpen: boolean;
  export let msg: string;
  export let txHash: string;

  const close = () => isOpen = false;
</script>


<Modal class="pil-modal" isOpen={isOpen} {close}>
  <ModalBody class="pil-modal-body">
    <Row>
      <Col class="modal-title">
        <img class="icon-middle" src="/icons/check-circle.svg" alt="placeholder"/>
        {msg}
      </Col>
      <Col class="col-auto">
        <img class="icon-large" src="/icons/close.svg" alt="placeholder" on:click={close}/>
      </Col>
    </Row>
    <Row>
      <Col class="modal-sub-title">
        Tx hash: <a href={txLink(txHash, $currentChainId)} target="_blank">{shortenAddress(txHash)}</a>
      </Col>
    </Row>
  </ModalBody>
</Modal>
